module.exports = __webpack_public_path__ + "static/media/close.36cf7717.svg";